import React from 'react';
import ReactDOM from 'react-dom/client';
import FullSendApp from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <FullSendApp />
  </React.StrictMode>
);
